import { UsersService } from '../../../modules/usermanagement/service/users/users.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, exhaustMap, catchError, withLatestFrom } from 'rxjs/operators';
import * as allActions  from '../../actions';


@Injectable()
export class sideMenuEffects {
    constructor(
        private actions$: Actions,
        private UserService: UsersService,
    ){ }
    sideMenu$ = createEffect(() =>
    this.actions$.pipe(
      ofType(allActions.sideMenu),
    exhaustMap(action =>
    this.UserService.sideMenu({body:action}).pipe(
      map(response =>
        {
      return allActions.sideMenuSuccess({response})
          }),
          catchError((error: any) => of(allActions.sideMenuFailure(error))))
      )
    )
  );

}
